'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { cn } from '@/lib/utils'

const ITEMS = [
  { href: '/play', label: 'Home', match: (p: string) => p === '/play' },
  { href: '/play/game', label: 'Play', match: (p: string) => p.startsWith('/play/game') },
  { href: '/play/me', label: 'How am I doing', match: (p: string) => p.startsWith('/play/me') },
  { href: '/play/library', label: 'Library', match: (p: string) => p.startsWith('/play/library') },
  { href: '/play/inbox', label: 'Inbox', match: (p: string) => p.startsWith('/play/inbox') },
  { href: '/play/leaderboard', label: 'Leaderboard', match: (p: string) => p.startsWith('/play/leaderboard') },
]

export function PlayerNav() {
  const pathname = usePathname() || ''
  return (
    <nav className="hidden md:flex items-center gap-1 text-sm">
      {ITEMS.map((item) => {
        const active = item.match(pathname)
        return (
          <Link
            key={item.href}
            href={item.href}
            className={cn(
              'px-3 py-1.5 rounded-md transition-colors',
              active
                ? 'bg-muted text-foreground font-medium'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted/50',
            )}
          >
            {item.label}
          </Link>
        )
      })}
    </nav>
  )
}
